import { Get } from "../../utils/apiUtils";

export async function getUserById(req: any): Promise<any> {
    const params:any = req.params;
    return await Get(`/user/${params.id}`, {});
}

export async function getAllUserData(req: any): Promise<any> {
    return await Get(`/dashboard/data`, {});
}

export async function getUserChat(req: any): Promise<any> {
    return await Get(`/chat/`, {});
}